document.addEventListener("DOMContentLoaded", function() {
    const operationElement = document.querySelector('.product__wrapper');
    
    if (operationElement) {
        const operationTags = operationElement.getAttribute('data-marketing-operation-tags');
        
        if (operationTags) {
            localStorage.setItem('operationTags', operationTags);
        }
    }
});